module.exports = __webpack_public_path__ + "img/logo-black.55f1015d.png";